export default __webpack_public_path__ + "static/media/image21tum.74dc392a.jpg";